function toogleExDemoPriceDiv() {
	var s = Number($(this).val());
	if (s === 6 ||
		s === 7) {
		$('#ExDemoDiv').slideDown('slow');
	} else {
		$('#ExDemoDiv').slideUp('slow');
	}
}

function checkTable() {
	$('.table-wrap-scroll').remove();
	$('.table-wrap').each(function(){
		if ($(this).find('table').width() > $(this).width()) {
			$(this).before('<div class="table-wrap-scroll">Scroll for more</div>');
		} else {
			$(this).previous('.table-wrap-scroll').remove();
		}
	});
}

$().ready(function() {

	$('.dropdown>a').on('click', function(e){
		e.preventDefault();
	});

	$('.collapse').on('click', function(){
		$(this).next('ul').slideToggle(150);
		e.preventDefault();
	});

	$('.tooltip').attr("aria-hidden","true");

	$('.tooltip-icon').on('click', function(e){
		e.preventDefault();
		$(this).siblings('.tooltip').attr("aria-hidden","false");
	});

	$('.tooltip-icon').on('mouseover focus', function(){
		$(this).siblings('.tooltip').attr("aria-hidden","false");
	});

	$('.tooltip-icon').on('mouseleave blur', function(){
		$(this).siblings('.tooltip').attr('aria-hidden','true');
	});

/*	if ($('#sortableList').length) {
		Sortable.create(sortableList, {
			// handle: '.move',
		  animation: 150,
			scroll: true,
			dataIdAttr: 'data-filename',
			onSort: function(evt) {
				var order = this.toArray();
				console.log(order);
			}
		});
	}
*/

	checkTable();
	$(window).on('resize', checkTable());

	var initial = Number($("#MainContent_ddlInventoryStatus option:selected").val());
	if (!(initial ===6 ||
		initial === 7)) {
		$('#ExDemoDiv').hide();
	}
	$('#MainContent_ddlInventoryStatus').change(toogleExDemoPriceDiv);

});
